import clamp from 'lodash/clamp';

export interface INumberFormatSeparators {
  thousandSeparator: string;
  decimalSeparator: string;
}

/** lodash `clamp(value, min, max)`, which applies no lower bound when `min` is undefined. */
export const clampToRange = (value: number, min: number | undefined, max: number) => {
  if (min === undefined) return clamp(value, max);
  return clamp(value, min, max);
};

/** `Number.isFinite`, which is true for finite numbers only. */
export const isFiniteNumber = (value: unknown): value is number => Number.isFinite(value);
